/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { InjectionToken } from '@angular/core';
import { ConfigurationLocationApplyResult, ConfigurationLocationPath, ConfigurationLocationPathPicker, ConfigurationLocationReturnCodes } from 'libs/sysque/toolbelt/feature/src/lib/models/configuration-location-return-codes';
import { SysqueElectricalState } from 'libs/sysque/toolbelt/feature/src/lib/models/sysque-electrical-state';
import { Observable } from 'rxjs';

export interface IConfigurationLocationFacade {
  verifyDirectory(path: string): Observable<ConfigurationLocationReturnCodes>
  getDockedState(): SysqueElectricalState;
  revertConfigurationLocation(): Observable<string>;
  applyNewConfigurationLocation(newFolderPath: string, isTetherConfiguration: boolean): Observable<ConfigurationLocationApplyResult>
  closeWindow(): Observable<boolean>;
  windowResize(height: number): void;
  folderSelection(): Observable<ConfigurationLocationPathPicker>;
  getFolderPath(): Observable<ConfigurationLocationPath>;
  updateLocalStorage(key: string, value: any): any;
  setTetheredConfiguration(path: string): Observable<void>;
}

export const CONFIGURATION_LOCATION_FACADE_TOKEN = new InjectionToken<IConfigurationLocationFacade>(
  'CONFIGURATION_LOCATION_FACADE_TOKEN'
);
